import formatString from "format-string-by-pattern";
import moment from "moment";
import React, { useEffect } from "react";
import { useForm, useFormState } from "react-final-form";
import { Col, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import * as S from "src/constants/StringConstants";
import { phoneMask, ssnMask, zipMask } from "src/views/ApplicationBuilder/validator";

const ProposedInsuredForm = ({ stateOptions, genderOptions }) => {
  const form = useForm();
  const { values } = useFormState();

  useEffect(() => {
    const DOB = values.dateOfBirth;

    if (DOB) {
      const birthDate = moment(DOB);
      const today = moment();
      const age = today.diff(birthDate, "years");

      if (!isNaN(age)) {
        form.change("issueAge", age.toString());
      }
    }
  }, [values.dateOfBirth]);

  return (
    <>
      <Row>
        <Col sm="12" className="app-form-header">
          <h4 className="form-title">{S.APP_PROPOSED_INSURED_TITLE}</h4>
        </Col>
      </Row>
      <Row>
        <Col sm="3">
          <TextField name="firstName" label={S.APP_FIELD_FIRST_NAME_LABEL} />
        </Col>
        <Col sm="3">
          <TextField name="middleName" label={S.APP_FIELD_ML_LABEL} />
        </Col>
        <Col sm="3">
          <TextField name="lastName" label={S.APP_FIELD_LAST_NAME_LABEL} />
        </Col>
        <Col sm="3">
          <TextField name="nameSuffix" label={S.APP_FIELD_SUFFIX_LABEL} />
        </Col>
      </Row>

      <Row>
        <Col rowSpan={3}>
          <TextField name="addressLine1" label={S.APP_FIELD_ADDRESS_LABEL} multiline />
        </Col>
        <Col>
          <Row>
            <TextField name="city" label={S.APP_FIELD_CITY_LABEL} />
          </Row>
          <Row>
            <Col>
              <TypeaheadField name="stateID" label={S.APP_FIELD_STATE_LABEL} options={stateOptions} />
            </Col>
            <Col>
              <TextField name="zip" label={S.APP_FIELD_ZIP_LABEL} placeholder={zipMask} parse={formatString(zipMask)} />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col sm="6">
          <SimpleDatePickerField label={S.APP_FIELD_DOB_LABEL} name="dateOfBirth" isFormMode showClear />
        </Col>
        <Col>
          <TextField name="issueAge" label={S.APP_FIELD_ISSUE_AGE_LABEL} />
        </Col>
        <Col>
          <CheckboxField name="saveAge" label={S.APP_FIELD_SAVE_AGE_LABEL} labelPosition="above" />
        </Col>
      </Row>

      <Row>
        <Col sm="6">
          <TypeaheadField name="genderTypeID" label={S.APP_FIELD_GENDER_LABEL} options={genderOptions} />
        </Col>
        <Col>
          <Row>
            <TextField
              name="workPhone"
              label={S.APP_FIELD_CELL_LABEL}
              placeholder={phoneMask}
              parse={formatString(phoneMask)}
              format={formatString(phoneMask)}
            />
          </Row>
        </Col>
      </Row>

      <Row>
        <Col sm="6">
          <TextField
            name="phone"
            label={S.APP_FIELD_PHONE_LABEL}
            type="tel"
            placeholder={phoneMask}
            parse={formatString(phoneMask)}
            format={formatString(phoneMask)}
          />
        </Col>
        <Col>
          <TextField
            name="ssn"
            label={S.APP_FIELD_SSN_LABEL}
            placeholder={ssnMask}
            parse={formatString(ssnMask)}
            format={formatString(ssnMask)}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <TypeaheadField name="driverLicenseStateID" label={S.APP_FIELD_DL_STATE_LABEL} options={stateOptions} />
        </Col>
        <Col>
          <TextField name="driverLicenseNumber" label={S.APP_FIELD_DL_LABEL} />
        </Col>
        <Col sm="6">
          <TextField name="email" label={S.APP_FIELD_EMAIL_LABEL} />
        </Col>
      </Row>
    </>
  );
};

export default ProposedInsuredForm;
